module.exports = __webpack_public_path__ + "static/media/tessellana_veyseli_006_APA.e1e3dbd2.png";